import { render, staticRenderFns } from "./Compliance.vue?vue&type=template&id=10a12e4e&"
import script from "./Compliance.vue?vue&type=script&lang=js&"
export * from "./Compliance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10a12e4e')) {
      api.createRecord('10a12e4e', component.options)
    } else {
      api.reload('10a12e4e', component.options)
    }
    module.hot.accept("./Compliance.vue?vue&type=template&id=10a12e4e&", function () {
      api.rerender('10a12e4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/Compliance.vue"
export default component.exports